import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
    state:{
        menuList:[
            {
                id: 1,
                name: '车辆',
                route: 'Vehicle'
            },
            {
                id: 2,
                name: '司机',
                route: 'Driver'
            },
            {
                id: 3,
                name: '订单',
                route: 'Order'
            },
            {
                id: 4,
                name: '登录',
                route: 'Login'
            }
        ]
    },

    mutations:{
        /**
         * 新增菜单
         * @param state
         * @param menus 需要新增的菜单数组，数组元素为对象，格式参照state中menuList元素
         */
        addMenus(state, menus){
            state.menuList.push(...menus);
        },

        /**
         * 删除菜单
         * @param state
         * @param menuIds 需要被删除的菜单的id组成的数组
         */
        removeMenus(state, menuIds){
            state.menuList = state.menuList.filter(item=>{
                return menuIds.indexOf(item.id) === -1;
            });
        },
        //按固定顺序新增菜单的方法请等待后续添加
                
        /**
         * 页面刷新保存导航状态
         * @param state
         * @param active 记录状态值
         */
        stoureNavActive(state,active){
        	state.navActive=active
        },
        stoureSideBarActive(state,active){
        	state.sideBarActive=active
        },
    },

    modules:{

    }
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js